import React from 'react';

import Typography from '@components/typography';

import { useDeviceDetect } from '@hooks/usedevicedetect';
import cn from 'classnames';

import '@styles/customise/progressbar.scss';
import { StepWizardChildProps, StepWizardNavProps } from 'interface';

const ProgresBar: React.FC<StepWizardNavProps> = ({
  stepWizard,
  stepOrder,
}) => {
  const steps = [];
  const wizard = stepWizard as StepWizardChildProps;
  const { isMobile } = useDeviceDetect();

  const stepLabel = (order: number) => {
    const step = stepOrder.find((item) => item.order === order);
    return stepOrder
      ? `${step?.name ?? ''} ${
          step?.items && (step?.items as number) > 1
            ? '(' + step?.items + ')'
            : ''
        }`
      : '';
  };

  for (let i = 1; i <= wizard.totalSteps; i += 1) {
    const isActive = wizard.currentStep > i || wizard.currentStep === i;
    const requiredStep = stepOrder.find((item) => item.order === i)?.required;
    const stepName = stepOrder.find((item) => item.order === i)?.name;

    steps.push(
      <span key={`step-${i}`} className={`step ${isActive ? 'active' : ''}`}>
        <button
          className="customise-progress__button"
          type="button"
          onClick={() => wizard.goToStep(i)}
        >
          <Typography
            className={`customise-progress__indicator ${
              requiredStep ? 'required' : ''
            }`}
            data-cy={`progress-button-${stepName}`}
            variant="caption"
            size="rg"
          >
            {stepLabel(i)}
          </Typography>
        </button>
      </span>
    );
  }

  return (
    <section
      className={cn(
        'customise-progress',
        isMobile ? 'customise-progress-mobile' : ''
      )}
      data-testid="customise-progress"
      data-cy="customise-progress"
    >
      {steps}
    </section>
  );
};

export default ProgresBar;
